export default __webpack_public_path__ + "static/media/ofering.dd0386ee.svg";